import Masthead from './components/Masthead';
import Hero from './components/Hero';
import Featured from './components/Featured';
import Ledger from './components/Ledger';
import Records from './components/Records';
import Sources, { Method } from './components/Sources';
import Faq from './components/Faq';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="bg-background-50 text-foreground-900">
      <Masthead />
      <main>
        <Hero />
        <Featured />
        <Ledger />
        <Records />
        <Sources />
        <Method />
        <Faq />
      </main>
      <SiteFooter />
    </div>
  );
}